export enum InteractionModifierEvent {
    SelectAllInRange = "SelectAll",
    SelectItemWithinRange = "SelectItemInList"
}
